import { useMemoSelector } from '@spa/redux/hooks'
import { DayTarget } from '@spa/scenes/Plannings/GridSelection'
import { getIsoDaysInTimeRange } from '@spa/scenes/Plannings/redux/selectors'
import type { FC } from 'react'
import React from 'react'

import Calendar from '../../Calendar/Calendar'
import { HeaderActions } from '../HeaderActions/HeaderActions'

import DayHeaderCell from './DayHeaderCell/DayHeaderCell'
import styles from './TeamDays.module.css'

type Props = {
  weeklyscheduleId: number
  teamId: number
  viewConfig?: {
    canAddMembership?: boolean
    canUpdateCounterMode?: boolean
    canSortContracts?: boolean
  }
}

const TeamDaysComponent: FC<Props> = ({
  teamId,
  weeklyscheduleId,
  viewConfig
}) => {
  const isoDays = useMemoSelector(getIsoDaysInTimeRange)

  return (
    <Calendar.Row className={styles.TeamDayRow}>
      <Calendar.Cell aside className='bg-neutral-50'>
        <HeaderActions viewConfig={viewConfig} teamId={teamId} />
      </Calendar.Cell>
      <Calendar.Cell noPadding noBorder>
        <Calendar.Row noBorder secondary>
          {isoDays.map((day, index) => (
            <Calendar.Cell key={day} noPadding>
              <DayTarget
                targetType={{
                  target: 'day',
                  data: {
                    weeklyscheduleId,
                    teamId,
                    day,
                    contractId: null
                  }
                }}
              >
                <DayHeaderCell
                  weeklyscheduleId={weeklyscheduleId}
                  day={day}
                  index={index}
                  teamId={teamId}
                />
              </DayTarget>
            </Calendar.Cell>
          ))}
        </Calendar.Row>
      </Calendar.Cell>
    </Calendar.Row>
  )
}

TeamDaysComponent.displayName = 'TeamDays'

export const TeamDays = React.memo(TeamDaysComponent)
